"use strict";

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createSuper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _inherits = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VoiceFocusAudioWorkletNode = void 0;

var VoiceFocusAudioWorkletNode = /*#__PURE__*/function (_ref) {
  _inherits(VoiceFocusAudioWorkletNode, _ref);

  var _super = _createSuper(VoiceFocusAudioWorkletNode);

  function VoiceFocusAudioWorkletNode() {
    _classCallCheck(this, VoiceFocusAudioWorkletNode);

    return _super.apply(this, arguments);
  }

  return VoiceFocusAudioWorkletNode;
}(typeof globalThis !== 'undefined' && globalThis['AudioWorkletNode'] || function Sadness() {
  _classCallCheck(this, Sadness);
});

exports.VoiceFocusAudioWorkletNode = VoiceFocusAudioWorkletNode;